import React from 'react'

interface EditSelfReminderFormTimeSlotProps {
    timeSlotEarly: boolean
    setTimeSlotEarly: React.Dispatch<React.SetStateAction<boolean>>
    timeSlotMidday: boolean
    setTimeSlotMidday: React.Dispatch<React.SetStateAction<boolean>>
    timeSlotLateEvening: boolean
    setTimeSlotLateEvening: React.Dispatch<React.SetStateAction<boolean>>
}

const EditSelfReminderFormTimeSlot: React.FC<EditSelfReminderFormTimeSlotProps> = ({
    timeSlotEarly,
    setTimeSlotEarly,
    timeSlotMidday,
    setTimeSlotMidday,
    timeSlotLateEvening,
    setTimeSlotLateEvening,
}: EditSelfReminderFormTimeSlotProps) => (
    <div className="flex flex-row gap-x-2 justify-center">
        <label className="flex flex-row flex-nowrap items-center justify-center border-2 rounded-xl box-border py px-2 radio-label items-center h-14 select-none">
            <input
                type="radio"
                id="time-morning"
                name="time-slot"
                className="hidden label"
                onChange={(e) => {
                    setTimeSlotEarly(e.currentTarget.checked)
                }}
                checked={timeSlotEarly}
            />
            <span className="whitespace-nowrap">8:00 - 12:00</span>
        </label>
        <label className="flex flex-row flex-nowrap items-center justify-center border-2 rounded-xl box-border py px-2 radio-label items-center h-14 select-none">
            <input
                type="radio"
                id="time-afternoon"
                name="time-slot"
                className="hidden label"
                onChange={(e) => {
                    setTimeSlotMidday(e.currentTarget.checked)
                }}
                checked={timeSlotMidday}
            />
            <span className="whitespace-nowrap">13:00 - 17:00</span>
        </label>
        <label className="flex flex-row flex-nowrap items-center justify-center border-2 rounded-xl box-border py px-2 radio-label items-center h-14 select-none">
            <input
                type="radio"
                id="time-evening"
                name="time-slot"
                className="hidden label"
                onChange={(e) => {
                    setTimeSlotLateEvening(e.currentTarget.checked)
                }}
                checked={timeSlotLateEvening}
            />
            <span className="whitespace-nowrap">18:00 - 22:00</span>
        </label>
    </div>
)

export default EditSelfReminderFormTimeSlot
export type { EditSelfReminderFormTimeSlotProps }
